import { EMPTY } from '../observable/empty';
import { operate } from '../util/lift';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function take(count) {
    return count <= 0
        ?
            function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var seen = 0;
            var operatorSubscriber = createOperatorSubscriber(subscriber, function (value) {
                if (++seen < count) {
                    subscriber.next(value);
                }
                else {
                    operatorSubscriber.unsubscribe();
                    subscriber.next(value);
                    subscriber.complete();
                }
            });
            source.subscribe(operatorSubscriber);
        });
}
//# sourceMappingURL=take.js.map